<script>
	import { handleSubmit, parseFormdata, shuffle } from "../utils.js";
	import { api_writeForm } from "../stores.js";
	import { useForm, validators, required } from "svelte-use-form";
	import { getExpParams, writeForm } from "../utils.js";
	import { onMount, onDestroy } from "svelte";

	export let onClose;
	const form = useForm();
	const expParams = getExpParams();
	const condition = Number(expParams["condition"]);

	console.log("Showing modal: default");
	console.log(condition);

	let videoElement;

	let videosControl = [
		"https://yourfeed-content.s3.amazonaws.com/240313-inoculation-study/bananas.mp4",
		"https://yourfeed-content.s3.amazonaws.com/240313-inoculation-study/curling.mp4",
		"https://yourfeed-content.s3.amazonaws.com/240313-inoculation-study/freezer.mp4",
	];

	let videosTreatment = [
		"https://yourfeed-content.s3.amazonaws.com/240313-inoculation-study/language.mp4",
	];
	let video;

	if (condition == 1) {
		// always play the same video for a single control participant
		if (localStorage.getItem("video")) {
			video = localStorage.getItem("video");
		} else {
			video = shuffle(videosControl)[0];
			localStorage.setItem("video", video);
		}
		console.log("Control condition", video);
	} else {
		video = videosTreatment[0];
	}

	writeForm($api_writeForm, {
		videoShown: video.split("/").pop(),
	});

	let videoStartTime;
	let videoEndTime;

	// determine when to show continue button
	let seconds = 105; // delay before showing button (set to 105 seconds)
	let startTime;
	let currentTime;
	let videoReachedEnd = true;
	let showContinue = false;

	function handlePlay() {
		console.log("Video started playing");
		if (!videoElement) {
			console.log("Video element is not yet initialized.");
			return;
		} else {
			videoElement.controls = true;
			videoElement.muted = false;
			videoElement.play();
			videoStartTime = new Date();
			let videoCurrentTime = videoElement.currentTime;
			let txt =
				Number(videoStartTime) +
				"-" +
				Number(Math.floor(videoCurrentTime));
			console.log(txt);
			writeForm($api_writeForm, {
				videoStart: txt,
			});
			writeForm($api_writeForm, {
				videoMuted: videoElement.muted,
			});
		}
	}

	function handleVideoEnd() {
		currentTime = +new Date();
		let timeDiffInS = (currentTime - startTime) / 1000;
		console.log("Time difference in seconds: ", timeDiffInS);
		if (timeDiffInS >= seconds) {
			videoReachedEnd = true;
			showContinue = true;
			document.removeEventListener(
				"visibilitychange",
				handleVisibilityChange,
			);
			window.removeEventListener("blur", handleWindowBlur);
			window.removeEventListener("focus", handleWindowFocus);
			console.log("Video has ended");
			localStorage.setItem("modalShown", 1);
			videoEndTime = +new Date();
			if (videoElement) {
				writeForm($api_writeForm, {
					videoEnd: Number(videoEndTime),
				});
				writeForm($api_writeForm, {
					videoMuted: videoElement.muted,
				});
			}
		} else {
			return;
		}
	}

	// track tab switch
	function handleVisibilityChange() {
		if (videoElement && !showContinue) {
			videoElement.controls = true;
			videoElement.muted = false;
			let currentTime = +new Date();
			if (document.visibilityState === "visible") {
				console.log("Tab is active");
				writeForm($api_writeForm, {
					tabActive: Number(currentTime),
				});
			} else {
				console.log("Tab is inactive");
				// Tab has become inactive (e.g., user switched to another tab)
				writeForm($api_writeForm, {
					tabInactive: Number(currentTime),
				});
			}
		}
	}

	function handleWindowBlur() {
		if (videoElement && !showContinue) {
			videoElement.controls = true;
			videoElement.muted = false;
			handleVolumeChange();
			let currentTime = +new Date();
			console.log(
				"Window has lost focus. User might have switched to a different app.",
			);
			writeForm($api_writeForm, {
				tabInactive: Number(currentTime),
			});
		}
	}

	function handleWindowFocus() {
		if (videoElement && !showContinue) {
			videoElement.controls = true;
			videoElement.muted = false;
			handleVolumeChange();
			let currentTime = +new Date();
			console.log("Window is in focus again.");
			writeForm($api_writeForm, {
				tabActive: Number(currentTime),
			});
		}
	}

	function disableEscapeKey(event) {
		if (event.key === "Escape") {
			event.preventDefault();
			event.stopPropagation(); // Stop the event from bubbling up
			console.log("Escape key disabled.");
		}
	}

	// Set up the event listener when the component mounts
	onMount(() => {
		document.body.style.position = "fixed"; // ensure scroll is fixed
		document.addEventListener("visibilitychange", handleVisibilityChange);
		window.addEventListener("blur", handleWindowBlur);
		window.addEventListener("focus", handleWindowFocus);
		// window.addEventListener("keydown", disableEscapeKey, true);
		startTime = +new Date();
		if (videoElement) {
			//videoElement.src = video;
			videoElement.controls = true; // Reassert control visibility
			videoElement.muted = false;
			handleVolumeChange();
			videoElement.load(); // Force reload if necessary (optional)
		}
	});

	onDestroy(() => {
		// Clean up the event listener when the component is destroyed
		document.body.style.position = ""; // ensure scroll is enabled
		document.removeEventListener(
			"visibilitychange",
			handleVisibilityChange,
		);
		window.removeEventListener("blur", handleWindowBlur);
		window.removeEventListener("focus", handleWindowFocus);
		// window.removeEventListener("keydown", disableEscapeKey, true);
	});

	$: if (videoElement) {
		videoElement.controls = true;
		videoElement.muted = false;
		handleVolumeChange();
	}

	const handleVolumeChange = () => {
		if (videoElement) {
			videoElement.muted = false;
			if (videoElement.volume < 0.3) {
				videoElement.volume = 1.0;
			}
		}
	};
</script>

<section class="default-container">
	<h1>
		Please turn up your computer's volume. Ensure the audio is not muted.
	</h1>
	<div>
		<video
			controls
			muted
			autoplay
			preload="auto"
			playsinline
			on:play={handlePlay}
			on:ended={handleVideoEnd}
			bind:this={videoElement}
			on:volumechange={handleVolumeChange}
			on:playing={handleVolumeChange}
			type="video/mp4"
			src={video}
		>
			<!-- <source src={video} type="video/mp4" /> -->
		</video>
	</div>
	<br />
	{#if showContinue}
		<form use:form>
			<button on:click|preventDefault={onClose}>Continue</button>
		</form>
	{:else}
		<button>You can continue after the video ends.</button>
	{/if}
</section>

<style>
	.default-container {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	h1 {
		font-size: 1.3rem;
		text-align: center;
	}
	video {
		width: 100%;
		height: auto;
		background-color: white !important;
	}
</style>
